module.exports = __webpack_public_path__ + "img/Ұлытау облысы.aaf449a0.png";